import '@ui/tokens/styles.css';
import './i18n';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { applyTheme } from './lib/theme';
import { installNativeBackGuard } from './app/nativeBack';
import { registerServiceWorker } from './features/pwa/registerServiceWorker';

applyTheme();

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

installNativeBackGuard();
registerServiceWorker();

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
